<template>
    <div class="top-line top-banner top-banner-wsj">
        <div class="logo-wsj"></div>
        <div class="left">
            <span>|</span>
            <router-link to="/">工作台</router-link>
            <span>|</span>
            <router-link to="/wsj/sjfx">数据分析</router-link>
            <span>|</span>
            <router-link to="/wsj/rlt">街区热力图</router-link>
            <span>|</span>
            <router-link to="/wsjsys/entity" v-if="validPriv('002')">系统管理</router-link>
        </div>
        <div class="right" v-if="isShowLogin">
            <div>
                <span>{{ userName }}</span>
                <a href="javascript:void(0);" @click="logout">退出</a>
            </div>
            <div>
                <img />
            </div>
        </div>
        <div class="right" v-if="!isShowLogin">
            <span>{{ time }}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "TopBanner",
    data() {
        return {
            userName: "",
            time: "",
            isShowLogin: true,
        };
    },
    watch: {
        $route: {
            handler(val, oldval) {
                this.isShowLogin = val.fullPath != "/wsj/rlt";
                if (!this.isShowLogin) {
                    this.setTime();
                }
                console.log(val);
            },
        },
    },
    created() {
        this.time = new Date().toLocaleString();
        this.isShowLogin = this.$route.fullPath != "/wsj/rlt";
        this.userName = this.$auth.getTokenData().User.UserName;
        this.setTime();
    },
    methods: {
        setTime() {
            let date = new Date();
            let y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            let h = date.getHours();
            let mm = date.getMinutes();
            let s = date.getSeconds();
            this.time =
                y +
                "-" +
                (m < 10 ? "0" : "") +
                m +
                "-" +
                (d < 10 ? "0" : "") +
                d +
                " " +
                (h < 10 ? "0" : "") +
                h +
                ":" +
                (mm < 10 ? "0" : "") +
                mm +
                ":" +
                (s < 10 ? "0" : "") +
                s;
            if (!this.isShowLogin) {
                setTimeout(() => this.setTime(), 500);
            }
        },
        validPriv(code) {
            return this.$auth.validPrivCodeBegin(code);
        },
        logout() {
            if (confirm("确定要退出吗？")) {
                this.$auth.removeToken();
                window.location = "/";
                //this.$router.push({ path: '/' });
            }
        },
    },
};
</script>
<style scoped>
.top-banner-wsj {
    background: url("/images/wsj/banner-bg-wsj.png");
}

.top-banner .logo-wsj {
    flex: none;
    background: url("/images/wsj/logo-wsj.png");
    width: 220px;
    height: 40px;
    display: inline-block;
}
</style>
